import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProjectsGrid from './ProjectsGrid';
import Footer from './Footer';

function CurrentProjects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Hero banner */}
      <section className="projects-hero">
        {/* Animated aurora orbs */}
        <div className="projects-hero-orb projects-hero-orb--1" aria-hidden="true" />
        <div className="projects-hero-orb projects-hero-orb--2" aria-hidden="true" />
        <div className="projects-hero-orb projects-hero-orb--3" aria-hidden="true" />
        <div className="projects-hero-orb projects-hero-orb--4" aria-hidden="true" />

        {/* Floating gold particles */}
        <div className="projects-hero-particles" aria-hidden="true">
          {Array.from({ length: 12 }).map((_, i) => (
            <span key={i} className="projects-hero-particle" />
          ))}
        </div>

        <div className="projects-hero-inner">
          <h1 className="projects-hero-title">
            <span className="title-emerald">Our Current</span>{' '}
            <span className="title-gold">Projects</span>
          </h1>
          <p className="projects-hero-subtitle">
            A glimpse into the bespoke luxury transformations we're crafting
            right now across Wales and beyond.
          </p>
          <Link to="/" className="projects-back-link">
            ← Back to Home
          </Link>
        </div>
      </section>

      {/* Decorative divider */}
      <hr className="projects-hero-divider" aria-hidden="true" />

      {/* Projects grid */}
      <ProjectsGrid />

      {/* CTA */}
      <section className="projects-cta-section">
        <div className="section-inner" style={{ textAlign: 'center' }}>
          <h2 className="section-title">
            <span className="title-emerald">Have a project</span>{' '}
            <span className="title-gold">in mind?</span>
          </h2>
          <p className="section-intro">
            We'd love to hear about your vision. Get in touch for a free
            consultation and let's create something extraordinary together.
          </p>
          <button
            type="button"
            className="projects-cta-btn"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Get in Touch
          </button>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default CurrentProjects;
